import React from 'react'

import clsx from 'clsx'

import Typography from 'components/Typography'
import UrlOpener from 'helpers/openUrl'

import classes from './Link.module.scss'

const getComponent = (href, onClick, disableSeo, forceComponent) => {
  if (forceComponent) return forceComponent
  if (!href && !onClick) return 'p'
  if (href && !disableSeo) return 'a'
  return 'button'
}

/** @type {import("./types").default} */
const Link = ({ disableSeo, disabled = false, href, className, children, onClick, variant, component, ...props }) => {
  const onClickHandler = event => {
    if (disabled) {
      event.preventDefault()
      return
    }
    if (onClick) {
      onClick(event)
    }
    if (href && disableSeo) {
      UrlOpener(href, { target: props.target || '_self', rel: props.rel })
    }
  }

  return (
    <Typography
      {...props}
      variant={variant || 'body-sm'}
      onClick={onClickHandler}
      href={disableSeo ? undefined : href}
      className={clsx('Link', classes.root, { [classes.disabled]: disabled }, className)}
      component={getComponent(href, onClick, disableSeo, component)}
    >
      {children}
    </Typography>
  )
}

export default Link
